import React from 'react'
import { TabsHeader, TabButton } from './AnalysisSectionTabHeader.styles'

export interface AnalysisSectionTabHeaderProps {
  children: React.ReactNode
  className?: string
}

export interface TabButtonProps {
  active: boolean
  onClick: () => void
  children: React.ReactNode
}

export const AnalysisSectionTabHeader: React.FC<AnalysisSectionTabHeaderProps> & {
  TabButton: React.FC<TabButtonProps>
} = ({ children, className }) => {
  return <TabsHeader className={className}>{children}</TabsHeader>
}

// Sub-component for TabButton
AnalysisSectionTabHeader.TabButton = ({ active, onClick, children }) => {
  return (
    <TabButton $active={active} onClick={onClick}>
      {children}
    </TabButton>
  )
}
